// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6fcda02","239":"b7f93927","453":"9353f0c5","455":"4e78bfbc","762":"5d2ab013","857":"0bfc95eb"}[chunkId] + ".chunk.js";
};